"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mapKeyboard_1 = require("./mapKeyboard");
const removeClusterGroupTabIndex_1 = require("./removeClusterGroupTabIndex");
const postKeyboard_1 = require("./postKeyboard");
class AccessibilityFeatures {
    constructor(container, map, markers, zoomMarker, baseClass) {
        (0, mapKeyboard_1.mapKeyboard)(container, map, markers, zoomMarker);
        (0, postKeyboard_1.postKeyboard)(container, baseClass);
        (0, removeClusterGroupTabIndex_1.removeClusterGroupTabIndex)(container);
    }
}
exports.default = AccessibilityFeatures;
